import React from 'react';
import PropTypes from 'prop-types';

import {
  Col,
  Grid,
  StatsCard,
  StatsCardHeader,
  StatsCardBody,
  StatsCardItem,
} from '@common/components';
import { DashboardSection } from '@dashboard/components';

import { useTranslation } from 'react-i18next';
import { numberFormat } from '@dashboard/util';

export default function ResumeCards({ resume }) {
  const { t } = useTranslation('dashboard\\ResumeCards');

  return (
    resume && (
      <DashboardSection title={t('title')}>
        <Grid
          align="stretch"
          justify="space-between"
          style={{ marginTop: '20px' }}
        >
          <Col xss={12} xs={12} sm={4} md={4}>
            <StatsCard>
              <StatsCardHeader>{t('centersLabel')}</StatsCardHeader>
              <StatsCardBody>
                <StatsCardItem
                  text={t('centersLabel')}
                  data={numberFormat(resume.total_centers)}
                />
                <StatsCardItem
                  text={t('classesLabel')}
                  data={numberFormat(resume.total_classes)}
                />
              </StatsCardBody>
            </StatsCard>
          </Col>
          <Col xss={12} xs={12} sm={4} md={4}>
            <StatsCard>
              <StatsCardHeader>{t('teachersLabel')}</StatsCardHeader>
              <StatsCardBody>
                <StatsCardItem
                  text={t('registeredLabel')}
                  data={numberFormat(resume.registered_teachers)}
                />
                <StatsCardItem
                  text={t('activeLabel')}
                  data={numberFormat(resume.active_teachers)}
                />
              </StatsCardBody>
            </StatsCard>
          </Col>
          <Col xss={12} xs={12} sm={4} md={4}>
            <StatsCard>
              <StatsCardHeader>{t('studentsLabel')}</StatsCardHeader>
              <StatsCardBody>
                <StatsCardItem
                  text={t('registeredLabel')}
                  data={numberFormat(resume.registered_students)}
                />
                <StatsCardItem
                  text={t('activeLabel')}
                  data={numberFormat(resume.active_students)}
                />
              </StatsCardBody>
            </StatsCard>
          </Col>
        </Grid>
      </DashboardSection>
    )
  );
}

ResumeCards.propTypes = {
  resume: PropTypes.object.isRequired,
};
